module.exports = __webpack_public_path__ + "e4a586b7f3afb103d1f8153fc513612c.png";